import { z } from 'zod';

import { ReplayDateSchema } from './marketConsole';
import { WatchlistSymbolSchema } from './marketHealth';

export const AddStockGroupSchema = z
  .object({
    symbol: WatchlistSymbolSchema,
    group: z.string().trim().min(1).max(80),
    /** First session the group applies to; earlier sessions keep the vendor industry. */
    effectiveFrom: ReplayDateSchema,
  })
  .strict();
export type AddStockGroupInput = z.infer<typeof AddStockGroupSchema>;

export interface StockGroupDto {
  id: string;
  symbol: string;
  group: string;
  effectiveFrom: string;
}
